var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInput',{attrs:{"type":"text","field-name":'question' + _vm.formQuestion.id,"required":"formQuestion.required"}})}
var staticRenderFns = []

export { render, staticRenderFns }